import React, { useEffect, useState } from 'react';
import { TableCell, TableRow } from 'ui-library/table';

import _ from 'lodash';
import { AddressSearchRequest } from 'api';
import { InputFullWidth, TableRowInput } from './TableRowInput';
import { Typography, TextField, Table, TableBody } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

export interface AdvancedAddressSearchProps {
	onChange: (search: AddressSearchRequest) => void;
	colSpan?: number;
}

export const AdvancedAddressSearch = ({ onChange, colSpan = 2 }: AdvancedAddressSearchProps) => {
	const [address, setAddress] = useState<AddressSearchRequest>({
		addressText: undefined,
		building: undefined,
		floor: undefined,
		unitNo: undefined,
		streetNo: undefined,
		street: undefined,
		suburb: undefined,
		postCode: undefined,
		state: undefined,
		// country: 'Australia',
		entityIds: undefined
	});

	const onFieldChange = _.debounce((field: string, value: string | null) => {
		if (_.isEmpty(value)) value = null;
		setAddress({ ...address, [field]: value });
	}, 200);
	const onFieldChangeEvent = (field: keyof AddressSearchRequest) => (e: React.SyntheticEvent) => {
		const value: string | null = _.get(e, 'target.value', undefined);
		onFieldChange(field, value);
	};

	useEffect(() => onChange(address), [address]);

	return (
		<>
			<Table>
				<TableBody>
					<TableRow>
						<TableCell>
							<Typography variant="h4">Property Search</Typography>
						</TableCell>
					</TableRow>
					<TableRowInput
						colSpan={colSpan}
						onChange={onFieldChangeEvent('suburb')}
						required
						placeholder="Suburb / City *"
						aria-label="suburb or city"
					/>
					<TableRow>
						<TableCell>
							<Autocomplete
								id="combo-box-demo"
								options={['VIC', 'QLD', 'NSW', 'ACT', 'NT', 'TAS', 'WA', 'SA']}
								getOptionLabel={(option) => option}
								onChange={(_, value) => onFieldChange('state', value)}
								renderInput={(params) => <TextField {...params} required placeholder="State *" aria-label="state" />}
							/>
						</TableCell>
						<TableCell>
							<InputFullWidth onChange={onFieldChangeEvent('postCode')} required placeholder="Postcode" aria-label="postcode" />
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>
							<InputFullWidth onChange={onFieldChangeEvent('floor')} placeholder="Floor No" aria-label="floor number" />
						</TableCell>
						<TableCell>
							<InputFullWidth onChange={onFieldChangeEvent('addressText')} placeholder="Unit Number (number)" aria-label="unit number" />
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell>
							<InputFullWidth
								onChange={onFieldChangeEvent('streetNo')}
								required
								placeholder="Street Number (number)"
								aria-label="street number"
							/>
						</TableCell>
						<TableCell>
							<InputFullWidth
								onChange={onFieldChangeEvent('street')}
								required
								placeholder="Street Name (text e.g. 'Main')"
								aria-label="street name"
							/>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</>
	);
};
